<div class="timesheet-trends">
  <div class="header">
    <div class="title-block">
      <button type="button" class="card-title-link" (click)="navigateToTimesheet()">
        <span class="ct-badge"><i class="material-icons">schedule</i></span>
      <span class="ct-text">Timesheet Metrics</span>
      <i class="material-icons ct-arrow">chevron_right</i>
    </button>
      <div class="header-stats" *ngIf="!loadError && !loading && totalContractors > 0">
        <span class="stat">
          <span class="stat-value">{{ totalContractors }}</span>
          <span class="stat-label">contractors</span>
        </span>
        <span class="stat-divider"></span>
        <span class="stat">
          <span class="stat-value">{{ approvalRate }}%</span>
          <span class="stat-label">approval rate</span>
        </span>
      </div>
    </div>
    <div class="filters">
      <div class="fs-field">
        <span class="fs-label">Month</span>
        <select
          class="native-select has-icon icon-cal"
          aria-label="Month"
          (change)="onMonthChange($any($event.target).value)"
        >
          <option *ngFor="let o of monthOptions" [value]="o.label" [selected]="o.value === selectedMonth && o.year === selectedYear">{{ o.label }}</option>
        </select>
      </div>
      <div class="fs-field">
        <span class="fs-label">Leader</span>
        <select
          class="native-select has-icon icon-person"
          aria-label="Leader"
          (change)="onLeaderChange($any($event.target).value)"
        >
          <option *ngFor="let o of leaderOptions" [value]="o.label" [selected]="o.value === selectedLeader">{{ o.label }}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="tiles" *ngIf="!loadError">
    <div class="tile" *ngFor="let tile of tiles" [attr.data-tone]="tile.tone">
      <div class="tile-value">{{ loading ? '—' : tile.value }}</div>
      <div class="tile-label">{{ tile.label }}</div>
    </div>
  </div>

  <div class="chart-wrapper" *ngIf="!loadError; else errorState">
    <ng-container *ngIf="!loading && chartData?.labels?.length; else emptyState">
      <p-chart
        type="bar"
        [data]="chartData"
        [options]="chartOptions"
      ></p-chart>
    </ng-container>
    <ng-template #emptyState>
      <div class="empty">
        <span *ngIf="loading">Loading…</span>
        <span *ngIf="!loading">No timesheet data for this month.</span>
      </div>
    </ng-template>
  </div>

  <ng-template #errorState>
    <div class="error">Unable to load timesheet metrics.</div>
  </ng-template>
</div>
